export enum ExamCategory {
  Circulatory = 'Circulatory',
  SkinCoatNails = 'Skin/Coat/Nails',
  Respiratory = 'Respiratory',
  Eyes = 'Eyes',
  LymphNodes = 'Lymph Nodes',
  Ears = 'Ears',
  GeneralAppearance = 'General Appearance',
  MouthDental = 'Mouth/Dental',
  MucousMembranes = 'Mucous Membranes',
  Musculoskeletal = 'Musculoskeletal',
  ClinicCategory = 'Clinic Category',
}
